import React, { useState } from "react";
import Popover from "@mlb/react-patterns/components/Popover/popover";
import {
  CameraOptionsPopoverWrapper,
  PlaybackButton,
} from "../fieldvision.style";
import CameraOptions from "./CameraOptions";
import {
  PopoverPlacement,
  ShowOnEvent,
} from "@mlb/react-patterns/components/Popover/popover.types";
import { PublicCameraOption } from "../../FieldVisionController";
import Icon from "@mlb/react-patterns/components/Icon/icon";
import { IconSizes } from "@mlb/react-patterns/components/Icon/icon.types";

interface CameraOptionsPopoverProps {
  setCameraType: (camType: PublicCameraOption) => void;
}
const CameraOptionsPopover = (props: CameraOptionsPopoverProps) => {
  const { setCameraType } = props;
  const [index, setIndex] = useState(0);
  const popoverContent = (
    <CameraOptions
      activeButtonIndex={index}
      setIndex={setIndex}
      setCameraType={setCameraType}
    />
  );

  return (
    <CameraOptionsPopoverWrapper className="cam">
      <Popover
        placement={PopoverPlacement.TOP_END}
        popoverContent={popoverContent}
        popoverOffset={[39, 20]}
        showOnEvent={ShowOnEvent.CLICK}
        flipPopover={true}
        closeOnPopperClick={false}
      >
        <PlaybackButton title="camera-options">
          <Icon name="camera-fv" size={IconSizes.LG} fill="#fff" />
        </PlaybackButton>
      </Popover>
    </CameraOptionsPopoverWrapper>
  );
};

export default CameraOptionsPopover;
